module.exports = __webpack_public_path__ + "img/Color services 2.svg";